var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 13,
    viewBox: "0 0 17 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.166748 1.29167C0.166748 0.71637 0.633118 0.25 1.20841 0.25H15.7917C16.367 0.25 16.8334 0.71637 16.8334 1.29167C16.8334 1.86696 16.367 2.33333 15.7917 2.33333H1.20841C0.633118 2.33333 0.166748 1.86696 0.166748 1.29167ZM2.25008 6.5C2.25008 5.9247 2.71645 5.45833 3.29175 5.45833H13.7084C14.2837 5.45833 14.7501 5.9247 14.7501 6.5C14.7501 7.0753 14.2837 7.54167 13.7084 7.54167H3.29175C2.71645 7.54167 2.25008 7.0753 2.25008 6.5ZM4.33342 11.7083C4.33342 11.133 4.79979 10.6667 5.37508 10.6667H11.6251C12.2004 10.6667 12.6667 11.133 12.6667 11.7083C12.6667 12.2836 12.2004 12.75 11.6251 12.75H5.37508C4.79979 12.75 4.33342 12.2836 4.33342 11.7083Z",
    fill: "#353434"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.f2613b265b8d77a1b2694b599ca8f8aa.svg";
export { ForwardRef as ReactComponent };